import client from "../Client";

const getVehicles = () => dispatch =>
  client.getVehicles().then(vehicles => {
    dispatch({
      type: "GET_VEHICLES",
      payload: { vehicles }
    });
  });

export default getVehicles;



// WEBPACK FOOTER //
// ./src/actions/vehicles.js